import React from 'react';
import { StateMachineContext } from '#src/state-machine/context';
import { getIsLoading } from '#src/state-machine/input-selectors';

export function LoadingProgressBar() {
  const isLoading = StateMachineContext.useSelector(getIsLoading);

  if (!isLoading) {
    return null;
  }

  return (
    <div className='loading-progress-bar'>
      <div className='loading-progress-bar-indicator' />
    </div>
  );
}
